export default __webpack_public_path__ + "static/media/food-draw.47553c89.png";